export default __webpack_public_path__ + "static/media/jet-logo.32b63d28.png";